import { getLanguage } from "../../utils/Common"

export const text = (key) => {
  const lang = getLanguage();  
  return multi[key] && (multi[key][lang] || "");
}

export const available = [
  {short: "tr", long: "Türkçe"},
  {short: "en", long: "English"},
  {short: "de", long: "Deutsche"},
];


const multi = {
  template: {
    "tr": "",
    "en": "",
    "de": "",
  },
  Mobile_Cihaz_degil: {
    "tr": "Mobile Cihaz Değil",
    "en": "Not A Mobile Device",
    "de": "Not A Mobile Device",
  },
  Bagli: {
    "tr": "Bağlı",
    "en": "Connected",
    "de": "Connected",
  },
  Bagli_degil: {
    "tr": "Bağlı Değil",
    "en": "Not Connected",
    "de": "Not Connected",
  },
  Cihaz: {
    "tr": "Cihaz",
    "en": "Device",
    "de": "Device",
  },
  Tarayici: {
    "tr": "Tarayıcı",
    "en": "Browser",
    "de": "Browser",
  },
  Baglanti_Durumu: {
    "tr": "Bağlantı Durumu",
    "en": "Connection Status",
    "de": "Connection Status",
  },
  bulten_header: {
    "tr": "Bültenler aşağıdaki gibidir!...",
    "en": "Announcements!...",
    "de": "Announcements!...",
  },
  Artemis_Atanan_isler: {
    "tr": "Artemis Atanan İşler",
    "en": "Artemis Assigned Works",
    "de": "Artemis Assigned Works",
  },
  uyarilar: {
    "tr": "Uyarılar",
    "en": "Notifications",
    "de": "Notifications",
  },
  isler_header: {
    "tr": "#$TeknAdet$# Adet Üstlenilmemiş İşiniz Bulunmaktadır!",
    "en": "You have #$TeknAdet$# Unassigned Works!",
    "de": "You have #$TeknAdet$# Unassigned Works!",
  },
  uyari_header: {
    "tr": "Uyarılarınız aşağıdaki gibidir!...",
    "en": "Notifications!...",
    "de": "Notifications!...",
  },
  Merkeze_Gonder: {
    "tr": "Merkeze Gönder",
    "en": "Send",
    "de": "Send",
  },
  Sonuc_Notu: {
    "tr": "Sonuç Notu",
    "en": "Result Note",
    "de": "Result Note",
  },
  islem_Yeri: {
    "tr": "İşlem Yeri",
    "en": "Location",
    "de": "Location",
  },
  Durum: {
    "tr": "Durum",
    "en": "State",
    "de": "State",
  },
  Tutar: {
    "tr": "Tutar",
    "en": "Total",
    "de": "Total",
  },
  BirimFiyat: {
    "tr": "Birim Fiyat",
    "en": "Unit Price",
    "de": "Unit Price",
  },
  Mesafe: {
    "tr": "Mesafe",
    "en": "Distance",
    "de": "Distance",
  },
  Plaka: {
    "tr": "Plaka",
    "en": "Plate",
    "de": "Plate",
  },
  GidilenYer: {
    "tr": "Gidilen Yer",
    "en": "Destination Point",
    "de": "Destination Point",
  },
  GelinenYer: {
    "tr": "Gelinen Yer",
    "en": "Starting Point",
    "de": "Starting Point",
  },
  Ekgaranti_Baslangic_Bitis_Tarihi: {
    "tr": "Ek Garanti Başlangıç - Bitiş Tarihi",
    "en": "Add. Warranty Start - End Date",
    "de": "Add. Warranty Start - End Date",
  },
  Baslangic_Bitis_Tarihi: {
    "tr": "Başlangıç - Bitiş Tarihi",
    "en": "Start - End Date",
    "de": "Start - End Date",
  },
  Garanti_Tarihi: {
    "tr": "Garanti Tarihi",
    "en": "Warranty Date",
    "de": "Warranty Date",
  },
  Garanti_Detay: {
    "tr": "Garanti Bilgileri",
    "en": "Warranty Details",
    "de": "Warranty Details",
  },
  Garanti_tip: {
    "tr": "Garanti Tipi",
    "en": "Warranty Type",
    "de": "Warranty Type",
  },
  iscilik_Toplamı: {
    "tr": "İşçilik Toplamı",
    "en": "Labour Total",
    "de": "Labour Total",
  },
  malzeme_Toplamı: {
    "tr": "Malzeme Toplamı",
    "en": "Material Total",
    "de": "Material Total",
  },
  serino: {
    "tr": "SeriNo",
    "en": "Serial",
    "de": "Serial",
  },
  uyıl: {
    "tr": "Üretim Yılı",
    "en": "Production Year",
    "de": "Production Year",
  },
  udonem: {
    "tr": "Üretim Dönemi",
    "en": "Production Month",
    "de": "Production Month",
  },
  Fis_Tarihce: {
    "tr": "Fiş Tarihçe",
    "en": "Service Paper History",
    "de": "Service Paper History",
  },
  Montaj_Uygunluk: {
    "tr": "Montaj Uygunluk Cevapları",
    "en": "Assembly Suitability Answers",
    "de": "Assembly Suitability Answers",
  },
  Sondaj_Durum: {
    "tr":"Sondaj Durum",
    "en":"Drilling Status",
    "de":"Drilling Status"
  },
  GelisYeri_MusteriDanismani_Arama: {
    "tr": "Geliş Yeri - Müşteri Danışmanı - Arama Tekrarı",
    "en": "Source - Customer Consultant - Repeated Calls",
    "de": "Source - Customer Consultant - Repeated Calls",
  },
  CagriMerkezi_Notu: {
    "tr": "ÇağrıMerkezi Açıklama",
    "en": "CallCenter Note",
    "de": "CallCenter Note",
  },
  Basvuru_Notu: {
    "tr": "Başvuru Notu",
    "en": "Application Note",
    "de": "Application Note",
  },
  is_emri_aciklamalar: {
    "tr": "İş Emri Detaylar",
    "en": "Work Order Details",
    "de": "Work Order Details",
  },
  Yol_Tarifi_Al: {
    "tr": "YolTarİfİ",
    "en": "Navigation",
    "de": "Navigation",
  },
  izinleri_Düzenle: {
    "tr": "İzİnler",
    "en": "Edit Permissions",
    "de": "Edit Permissions",
  },
  Randevu: {
    "tr": "Randevu",
    "en": "Appointment",
    "de": "Appointment",
  },
  cagri_tarihi: {
    "tr": "Çağrı Tarihi",
    "en": "Call Date",
    "de": "Call Date",
  },
  Adres: {
    "tr": "Adres",
    "en": "Address",
    "de": "Address",
  },
  Telefon_Arayan: {
    "tr": "Telefon / Arayan",
    "en": "Phone / Caller",
    "de": "Phone / Caller",
  },
  Artemis_Giris: {
    "tr": "Artemis Giriş",
    "en": "Artemis Login",
    "de": "Artemis Login",
  },
  Giris_Yapiniz: {
    "tr": "Kullanıcı Girişi Yapınız!...",
    "en": "Please Login!..",
    "de": "Please Login!..",
  },
  Kullanıcı_Adı: {
    "tr": "Kullanıcı Adı",
    "en": "Username",
    "de": "Username",
  },
  Parola: {
    "tr": "Şifre",
    "en": "Password",
    "de": "Password",
  },
  Giris: {
    "tr": "Oturumu Aç",
    "en": "Login",
    "de": "Login",
  },
  is_emirleri: {
    "tr": "İş Emirleri",
    "en": "Work Orders",
    "de": "Work Orders",
  },
  Uyari_Merkezi: {
    "tr": "Ç.Merkezi Uyarılar",
    "en": "Notifications",
    "de": "Notifications",
  },
  Yorum: {
    "tr": "Yorum",
    "en": "Comments",
    "de": "Comments",
  },
  Bultenler: {
    "tr": "Bülten",
    "en": "Announcements",
    "de": "Announcements",
  },
  Kullanici: {
    "tr": "Kullanıcı",
    "en": "Profile",
    "de": "Profile",
  },
  Mesajlar: {
    "tr": "Mesajlar",
    "en": "Messages",
    "de": "Messages",
  },
  Baglanti: {
    "tr": "Cihaz",
    "en": "Connection",
    "de": "Connection",
  },
  Koordinat: {
    "tr": "Lokasyon",
    "en": "Coordinats",
    "de": "Coordinats",
  },
  Kayit: {
    "tr": "Kayıt",
    "en": "Save",
    "de": "Save",
  },
  iyi_gunler: {
    "tr": "Merhaba",
    "en": "Hello",
    "de": "Hello",
  },
  Arama_Yap: {
    "tr": "Arama Yap...",
    "en": "Search...",
    "de": "Search...",
  },
  Musteri: {
    "tr": "Müşteri",
    "en": "Customer",
    "de": "Customer",
  },
  Acıklama: {
    "tr": "Açıklama",
    "en": "Details",
    "de": "Details",
  },
  Tarihce: {
    "tr": "Tarihçe",
    "en": "History",
    "de": "History",
  },
  Urun: {
    "tr": "Ürün",
    "en": "Product",
    "de": "Product",
  },
  Garanti: {
    "tr": "Garanti",
    "en": "Warranty",
    "de": "Warranty",
  },
  Hizmet: {
    "tr": "Hizmet",
    "en": "Defect",
    "de": "Defect",
  },
  YolOdeme: {
    "tr": "Yol Ödeme",
    "en": "Travel Expense",
    "de": "Travel Expense",
  },
  Fotograf: {
    "tr": "Fotoğraf",
    "en": "Photo",
    "de": "Photo",
  },
  Doğrulama: {
    "tr": "Sms",
    "en": "Validation",
    "de": "Validation",
  },
  Sonlandır: {
    "tr": "İş Emri Kapatma",
    "en": "Finish",
    "de": "Finish",
  },
  Yazdır: {
    "tr": "Yazdır",
    "en": "Print",
    "de": "Print",
  },
  template2: {
    "tr": "",
    "en": "",
    "de": "",
  },
}


